import { render } from "./adobe_iframe.vue?vue&type=template&id=bf9d250a&scoped=true"
import script from "./adobe_iframe.vue?vue&type=script&lang=js"
export * from "./adobe_iframe.vue?vue&type=script&lang=js"

import "./adobe_iframe.vue?vue&type=style&index=0&id=bf9d250a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9d250a"]])

export default __exports__